




























































import { Component, Prop, Vue } from "vue-property-decorator";
import axios from "axios";
import { General } from "@/services/General";
import CommunicationCategory from "@/services/CommunicationCategory";
import { ICommunicationTypeResult } from "@/interfaces/ICommunicationTypeResult";
import { ICommunicationSubCategory } from "@/interfaces/ICommunicationSubCategory";
@Component
export default class CommunicationCategoryDetail extends Vue {
  @Prop({ type: String, required: false })
  idCategorySelected;
  @Prop({ type: Boolean, required: true })
  addMode;
  loading: boolean = false;
  optionCommType = new Array();
  newSubCategoryName : string = "";
  communicationCategory = new CommunicationCategory();
  isSaveClicked : boolean = false;
async deleteCategoryDo(idCategory:string){
        General.confirm(
      "Do you want delete this category:" + this.communicationCategory.name + "?",
      this,
      async () => {
        if(await this.deleteCategory(idCategory)){
        this.$emit("categories-Search");
        this.$bvModal.hide('category-detail-update-modal');
        }
      }
        );
    }
//Il delete e l'add devono returnare un true se l'operazione è andata a buon fine e solo in tal caso chiedere la modale di dettaglio
  async deleteCategory(idCategory:string): Promise<boolean>{
    try{
      this.loading = true;
      await axios.delete(General.GetApiUrl('/api/communication/DeleteCommunicationCategory/' + idCategory),{withCredentials:true});
    General.showAlertSuccess("Category successfully deleted!",this);
    return true;
    }catch(exception){
      this.$fire({
                        title: "Error ",
                        text:exception.response.data,
                        type: "error"
                    });
                    return false;
    }finally{
      this.loading = false;
    }
  }

  removeSubCategory(subCategory:ICommunicationSubCategory,index:number){
    General.confirm(
      "Do you want remove subCategory:" + subCategory.name + "?",
      this,
      async () => {
        this.communicationCategory.communicationSubCategories.splice(index,1);
      }  
    ); 
  }

  async mounted() {
    if(!this.addMode)
    this.communicationCategory = await this.getCommunicationCategoryById(
      this.idCategorySelected
    );
    this.optionCommType = this.setOptions(
      this.optionCommType,
      await this.getCommunicationTypes(),
      "id",
      "name",
      false
    );
  }
  async addOrUpdateCategory(){
    this.isSaveClicked = true;
    if(!this.communicationCategory.name || !this.communicationCategory.typeId)
      General.showAlertDanger("Please check required fields",this)
      else
    if(!this.addMode)
      await this.updateCommunicationCategoryDo();
    else 
     await this.addCommunicationCategoryDo();
     }

  async updateCommunicationCategoryDo(){
     General.confirm(
      "Do you want save changes for category:" + this.communicationCategory.name + "?",
      this,
      async () => {
      if(await this.updateCommunicationCategory(this.communicationCategory)){
      this.$bvModal.hide('category-detail-update-modal');
      this.$emit("categories-Search");
      }
      this.isSaveClicked = false;
      }
    );
  }

    async addCommunicationCategoryDo(){
     General.confirm(
      "Do you want add this category:" + this.communicationCategory.name + "?",
      this,
      async () => {
      if(await this.addCommunicationCategory(this.communicationCategory)){
      this.$emit("categories-Search");
      this.$bvModal.hide('category-detail-add-modal');
      }
      this.isSaveClicked = false;
      }
    );
  }

  async addCommunicationCategory(communicationCategory:CommunicationCategory):Promise<boolean>{
    this.loading = true;
    try{
       await axios({
        method: "post",
        url: General.GetApiUrl("/api/communication/AddCommunicationCategory"),
        data: {
             TypeId:communicationCategory.typeId,
             Name:communicationCategory.name,
             CommunicationSubCategories:communicationCategory.communicationSubCategories,
             CommunicationType : {Name : communicationCategory.typeName}
          },
        withCredentials: true
      });
      this.$emit("categories-Search");
      General.showAlertSuccess("Category successfully added", this);
      return true;
    }catch (exception) {
               this.$fire({
                        title: "Error ",
                        text:exception.response.data,
                        type: "error"
                    });
      return false;
    } finally {
      this.loading = false;
    }
  }
  async updateCommunicationCategory(communicationCategory : CommunicationCategory):Promise<Boolean>{
    this.loading = true;
    try{
    await axios({
        method: "post",
        url: General.GetApiUrl('/api/communication/UpdateCommunicationCategory'),
        data: {
           IdCategory : communicationCategory.idCategory,
           Name : communicationCategory.name,
           CommunicationSubCategories : communicationCategory.communicationSubCategories,
           TypeId : communicationCategory.typeId
        },
        withCredentials: true
      });
      this.$emit("categories-Search");
      General.showAlertSuccess("SubCategory successfully updated", this);
      return true;
    } catch (exception) {
               this.$fire({
                        title: "Error ",
                        text:exception.response.data,
                        type: "error"
                    });
                    return false;
    } finally {
      this.loading = false;
    }
  }

  async addCommunicationSubCategoryDo(){
    let exists = this.communicationCategory.communicationSubCategories.find(subCat => subCat.name.trim().toLowerCase() == this.newSubCategoryName.trim().toLowerCase());
    let newSubCategory : ICommunicationSubCategory = {
    idSubCategory: "",
    name: "",
    idCategory: "",
    communicationCategory: new CommunicationCategory(),
  };
      
    if(!exists){
      newSubCategory.name = this.newSubCategoryName;
      if(!this.addMode)
    newSubCategory.idCategory = this.idCategorySelected;
  
     this.communicationCategory.communicationSubCategories.push(newSubCategory);
     this.newSubCategoryName = "";
    }
    else
      General.showAlertDanger("SubCategory: " + this.newSubCategoryName + " alredy exists for this category!",this);
  }

  async getCommunicationTypes(): Promise<[ICommunicationTypeResult]> {
    this.loading = true;
    try {
      let response = await axios.get<[ICommunicationTypeResult]>(
        General.GetApiUrl("/api/communication/GetCommunicationTypes"),
        { withCredentials: true }
      );
      if (response.data) return response.data;
    } catch (exception) {
      General.HandleError(exception, this);
    } finally {
      this.loading = false;
    }
  }

  async getCommunicationCategoryById(
    idCategory: string
  ): Promise<CommunicationCategory> {
    this.loading = true;
    try {
      let response = await axios.get<CommunicationCategory>(
        General.GetApiUrl(
          "/api/Communication/GetCommunicationCategoryById/" + idCategory
        ),
        { withCredentials: true }
      );
      if (response.data) return response.data;
    } catch (exception) {
      General.HandleError(exception, this);
    } finally {
      this.loading = false;
    }
  }

  setOptions(
    arrayTarget: any[],
    arraySource: any[],
    aliasId: string,
    aliasValue: string,
    pushEmptyItem: boolean = true
  ): any[] {
    if (pushEmptyItem) arrayTarget.push({ value: null, text: "" });
    arraySource.forEach(function (el: any) {
      arrayTarget.push({ value: el[aliasId], text: el[aliasValue] });
    });
    return arrayTarget;
  }

   returnState(condiction:boolean,clickButton:boolean) : boolean{
       if(clickButton)
           return condiction  
       else return null;
    }
}
